const dtGenerator                = require('../../../../../components/dt/dt-generator')
const dtHandler                  = require('../../../../../components/dt/dt-handler')
const dtSearch                   = require('../../../../../components/dt/dt-search')
const dtSearchHandler            = require('../../../../../components/dt/dt-search-handler')
const reconciliationMenu         = require('./accountreconciliation-menu')
const {organizeRow, tableDetail} = require('./accountreconciliation-dt-handler')

var htmlDt          = {}
var HTMLwasSelected = false

function HTMLselect() {
      dtHandler.HTMLselect('accountreconciliation-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected = true
}

export function start(detail) {
      if (!document.getElementById('accountreconciliation-dt')) return
      if (!HTMLwasSelected) HTMLselect()
      detail.entity = 'accountreconciliation'
      detail.dest = 'accountreconciliation'
      obj[detail.act].start(detail)
}

const obj = {
      addRow:         { start: (detail)=>{ dtGenerator.addRow(detail, htmlDt)                                     }},
      updateRow:      { start: (detail)=>{ updateRow(detail)                                                      }},
      tableOptions:   { start: (detail)=>{ reconciliationMenu.start(detail, htmlDt)                               }},
      trMenu:         { start: (detail)=>{ reconciliationMenu.start(detail, htmlDt)                               }},
      filter:         { start: (detail)=>{ dtSearch.filter(detail, htmlDt)                                        }},
      filterShowHide: { start: (detail)=>{ dtSearch.filterShowHide(detail, htmlDt)                                }},
      loadMore:       { start: (detail)=>{ dtSearch.loadMore(detail, htmlDt)                                      }},
      searching:      { start: (detail)=>{ dtSearch.searching(detail, htmlDt)                                     }},
      select:         { start: (detail)=>{ dtSearch.select(detail, htmlDt, true)                                  }},
      th:             { start: (detail)=>{ dtSearch.th(detail, htmlDt)                                            }},
      refresh:        { start: (detail)=>{ dtSearchHandler.cleanDt(htmlDt); dtSearch.select(detail, htmlDt, true) }},
}

function updateRow(detail) {
      const row = document.getElementById(`accountreconciliation-tableRow-${detail.row[0].id}`)
      if (!row) return
      dtGenerator.updateRow(detail, htmlDt)
      row.querySelector('input[type="checkbox"]').classList.add('checkAll')
}
